<div class="inherit_permission_button">
  <button
    mat-raised-button
    adf-inherit-permission
    [nodeId]="nodeId"
    [attr.color]="toggleStatus ? 'accent' : 'primary'"
    (error)="onError($event)"
    (updated)="onUpdatedPermissions($event)"
  >
    {{
      (toggleStatus
        ? 'PERMISSIONS.DIALOG.INHERITED_PERMISSIONS_BUTTON'
        : 'PERMISSIONS.DIALOG.INHERIT_PERMISSIONS_BUTTON') | translate
    }}
  </button>
  <button mat-button (click)="openAddPermissionDialog()">
    {{ 'PERMISSIONS.DIALOG.ADD_USER_OR_GROUP' | translate }}
  </button>
</div>

<adf-permission-list
  #permissionList
  [nodeId]="nodeId"
  (error)="onError($event)"
  (update)="onUpdate()"
>
</adf-permission-list>
